import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=18052b12&scoped=true&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"
import style0 from "./Turntable.vue?vue&type=style&index=0&id=18052b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18052b12",
  null
  
)

export default component.exports